"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedeemResultDtoReferrerOutcomeEnum = exports.RedeemResultDtoRefereeOutcomeEnum = void 0;
exports.instanceOfRedeemResultDto = instanceOfRedeemResultDto;
exports.RedeemResultDtoFromJSON = RedeemResultDtoFromJSON;
exports.RedeemResultDtoFromJSONTyped = RedeemResultDtoFromJSONTyped;
exports.RedeemResultDtoToJSON = RedeemResultDtoToJSON;
exports.RedeemResultDtoToJSONTyped = RedeemResultDtoToJSONTyped;
/**
 * @export
 */
exports.RedeemResultDtoRefereeOutcomeEnum = {
    CreditActivated: 'credit_activated',
    CreditPending: 'credit_pending'
};
/**
 * @export
 */
exports.RedeemResultDtoReferrerOutcomeEnum = {
    CreditActivated: 'credit_activated',
    CreditPending: 'credit_pending',
    SkippedNoReferrerReward: 'skipped_no_referrer_reward',
    SkippedBelowThreshold: 'skipped_below_threshold'
};
/**
 * Check if a given object implements the RedeemResultDto interface.
 */
function instanceOfRedeemResultDto(value) {
    if (!('redeemed' in value) || value['redeemed'] === undefined)
        return false;
    if (!('refereeOutcome' in value) || value['refereeOutcome'] === undefined)
        return false;
    if (!('referrerOutcome' in value) || value['referrerOutcome'] === undefined)
        return false;
    return true;
}
function RedeemResultDtoFromJSON(json) {
    return RedeemResultDtoFromJSONTyped(json, false);
}
function RedeemResultDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'redeemed': json['redeemed'],
        'refereeOutcome': json['refereeOutcome'],
        'refereeExpiresAt': json['refereeExpiresAt'] == null ? undefined : json['refereeExpiresAt'],
        'referrerOutcome': json['referrerOutcome'],
        'referrerExpiresAt': json['referrerExpiresAt'] == null ? undefined : json['referrerExpiresAt'],
    };
}
function RedeemResultDtoToJSON(json) {
    return RedeemResultDtoToJSONTyped(json, false);
}
function RedeemResultDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'redeemed': value['redeemed'],
        'refereeOutcome': value['refereeOutcome'],
        'refereeExpiresAt': value['refereeExpiresAt'],
        'referrerOutcome': value['referrerOutcome'],
        'referrerExpiresAt': value['referrerExpiresAt'],
    };
}
